<template>
  <v-app class="app" color="purple">
    <v-overlay :value="loadPage.show" class="text-center" :opacity="0.7" z-index="1000">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
      <p>{{loadPage.message}}</p>
    </v-overlay>

    <!-- If isLoggedIn puede ver el menú, sino ve el admin basico -->

    <v-app-bar class="bar" 
               app height="64" 
               :color="soofia && $vuetify.theme.dark ? '' : soofia && !$vuetify.theme.dark ? 'white' : 'primary'" 
               :dark="$vuetify.theme.dark" elevation="0">
      <v-btn v-if="$store.getters.isLoggedIn" icon @click="drawer = !drawer" :dark="$vuetify.theme.dark" :disabled="($route.name == 'Unauthorized' || $route.name == 'Authenticate')">
        <v-icon :color="soofia ? 'dark' : 'white'">mdi-menu</v-icon>
      </v-btn>
      <Header :drawer="drawer"></Header>
    </v-app-bar>
    
    <v-navigation-drawer v-model="drawer" v-if="drawer && $store.getters.isLoggedIn" app  class="navigation-custom">
      <NavigationMenu></NavigationMenu>
    </v-navigation-drawer>

    <v-main class="secondary">
      <v-container fluid class="pa-6">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-snackbar
      v-model="$store.state.snackbar.show"
      :color="$store.state.snackbar.color"
      timeout="3000">
      <!-- <span class="d-flex justify-center text-center">{{ $store.state.snackbar.text }}</span> -->
      <div class="d-flex justify-center text-center" v-html="$store.state.snackbar.text"></div>
    </v-snackbar>
    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>

import Header from "./views/app/Header.vue";
import NavigationMenu from "./views/app/NavigationMenu.vue";
import eventBus from "./event-bus.js"
import { soofiaLightTheme, soofiaDarkTheme, defaultTheme } from './plugins/themes'
export default {
  name: 'App',

  components: {
    Header,
    NavigationMenu,
  },
  data: () => ({
    drawer: true,
    loadPage : { show: false, message: 'Cargando...' }
  }),
  created(){
    // const data = {
    //                 show: false,
    //                 message:"",
    //                 color: "",
    //             }

    // this.$store.dispatch("quickMessage/activeMessage", data);
  },
  mounted(){
    let vm = this;
    eventBus.$on("loadPage", function (data) {
       vm.loadPage = data;
    });
    this.setTheme()
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    currentRouteName() {
      return this.$route.name;
    },
    soofia() {
      return this.$store.state.user.parameters?.soofia || false
    }
  },
  watch:{
    '$route.name'(val){
      if(val == 'Unauthorized' || val == 'Authenticate') this.drawer = false
      else this.drawer = true
    },
    soofia() {
      this.setTheme()
    }
  },
  methods: {
    // se setea colores de soofia
    setTheme() {
      if(this.$store.state.user.parameters?.soofia) {
        // this.$vuetify.theme.dark = true
        this.$vuetify.theme.themes['light'] = soofiaLightTheme
        this.$vuetify.theme.themes['dark'] = soofiaDarkTheme
      } else {
        this.$vuetify.theme.themes['light'] = defaultTheme
      }
    }
  }
};
</script>

<style>
  .bar {
    box-shadow: 0px 6px 32px #7052FB33;
    opacity: 1;
  }

  .navigation-custom {
    background: #f7f7f7 0% 0% no-repeat padding-box;
    opacity: 1;
    width: 270px !important;
  }

  /* .main-custom {
    background: #f7f7f7 0% 0% no-repeat padding-box;
    opacity: 1;
  } */


  /* width */
  ::-webkit-scrollbar {
    width: .9rem !important;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f2f3f8 !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #B2B2B2 !important;
    border-radius: 10px !important;
  }
</style>
